import { STATUS } from "@/constant/statusConstants";
import { TEXT_DIRECTION } from "@/constant/Languages/text-direction";

const getLanguageInitialValues = (showData = null) => {
  const data = showData?.data;
  return {
    title: data?.title || "",
    label: data?.label || "",
    slug: data?.slug || "",
    code: data?.code || "",
    code_alpha_3: data?.code_alpha_3 || "",
    rtl: data?.rtl || TEXT_DIRECTION.LEFT_TO_RIGHT,
    icon: data?.icon || null,
    status: data?.status || STATUS.INACTIVE,
  }
};

export default getLanguageInitialValues;
